module.exports = __webpack_public_path__ + "img/logo.27abc5e3.png";